import { Colors, Services, regExp } from '@sigma-frontend-libs/commons'
import { GENDERS } from '@sigma-legacy-libs/essentials/lib/constants'
import { NAME_REGEXP } from '@sigmasms/commons'

import { buttonModes, components, icons, sizes } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'
import arrow from '@/components/misc/arrow'
import sticker from '@/components/sticker'

function renderFieldPhone(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.phone,
        label: this.getTranslate(`${Services.contacts}.labels.phone`),
        error: this.errors.phone,
        required: this.required.phone,
        clearable: !this.blocked.phone,
        trim: true,
        autofocus: !this.isFilter,
        dense: true,
        disabled: this.blocked.phone,
        maxlength: 25,
        details: false,
        mask: regExp.phoneSoft
      },
      on: {
        input: event => {
          this.proxy.phone = event
        }
      }
    }
  )
}

function renderFieldEmail(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.email,
        label: this.getTranslate(`${Services.contacts}.labels.email`),
        error: this.errors.email,
        required: this.required.email,
        clearable: !this.blocked.email,
        trim: true,
        dense: true,
        details: false,
        disabled: this.blocked.email
      },
      on: {
        input: event => {
          this.proxy.email = event
        }
      }
    }
  )
}

function renderFieldLastName(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.lastName,
        defaultValue: undefined,
        label: this.getTranslate(`${Services.contacts}.labels.lastName`),
        error: this.errors.lastName,
        clearable: true,
        mask: NAME_REGEXP,
        trim: true,
        dense: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.lastName = event
        }
      }
    }
  )
}
function renderFieldFirstName(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.firstName,
        defaultValue: undefined,
        label: this.getTranslate(`${Services.contacts}.labels.firstName`),
        error: this.errors.firstName,
        clearable: true,
        mask: NAME_REGEXP,
        trim: true,
        dense: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.firstName = event
        }
      }
    }
  )
}
function renderFieldMiddleName(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.middleName,
        defaultValue: undefined,
        label: this.getTranslate(`${Services.contacts}.labels.middleName`),
        error: this.errors.middleName,
        clearable: true,
        mask: NAME_REGEXP,
        trim: true,
        dense: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.middleName = event
        }
      }
    }
  )
}

function renderFieldGender(h) {
  return h(
    components.select,
    {
      props: {
        value: this.proxy.gender || undefined,
        defaultValue: undefined,
        label: this.getTranslate(`${Services.contacts}.labels.gender`),
        items: GENDERS.map(gender => {
          return {
            title: this.getTranslate(`misc.genders.${gender}`),
            value: gender
          }
        }),
        clearable: true,
        dense: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.gender = event
        }
      }
    }
  )
}
function renderFieldDate(h) {
  return h(
    components.menu,
    {
      class: `${Services.contacts}-form__date-menu`,
      props: {
        value: this.show,
        closeOnContentClick: false,
        rounded: true,
        maxWidth: 282
      },
      on: {
        show: event => {
          this.show = event
        }
      }
    },
    [
      h(
        sticker,
        {
          props: {
            value: this.computedDate,
            label: this.getTranslate(`${Services.contacts}.labels.date`),
            icon: icons.event,
            color: Colors.grey,
            width: '100%',
            to: { service: undefined }
          },
          slot: 'activator'
        }
      ),

      h(
        'div',
        {
          class: `${Services.contacts}-form__date-content`
        },
        [
          h(
            components['date-picker'],
            {
              props: {
                value: this.proxy.date,
                localeTag: this.locale,
                range: false
              },
              on: {
                input: event => {
                  this.proxy.date = event
                }
              }
            }
          ),

          h(
            'div',
            {
              class: `${Services.contacts}-form__date-actions`
            },
            [
              h(
                button,
                {
                  props: {
                    label: this.getTranslate('misc.buttons.clear'),
                    mode: buttonModes.flat,
                    disabled: !this.proxy.date,
                    size: sizes.small
                  },
                  on: {
                    click: () => {
                      this.proxy.date = undefined
                    }
                  }
                }
              ),

              h(
                button,
                {
                  props: {
                    label: this.getTranslate('misc.buttons.close'),
                    mode: buttonModes.flat,
                    size: sizes.small
                  },
                  on: {
                    click: () => {
                      this.show = false
                    }
                  }
                }
              )
            ]
          )
        ]
      )
    ]
  )
}

function renderCustomTextField(h, field, index) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy[field],
        defaultValue: undefined,
        label: `${this.getTranslate(`${Services.contacts}.labels.custom`)} ${index + 1}`,
        clearable: true,
        trim: true,
        dense: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy[field] = event
        }
      },
      key: `field-${index}`
    }
  )
}
function renderPermanentButton(h, field) {
  if (this.permanent) {
    return h(
      button,
      {
        props: {
          mode: buttonModes.flat,
          color: Colors.primary,
          icon: icons.content_paste_go,
          tooltip: this.getTranslate(`${Services.contacts}.tooltips.permanent`)
        },
        on: {
          click: () => {
            this.proxy[field] = 'permanent'
          }
        }
      }
    )
  }
}
function renderCustomField(h, field, index) {
  switch (index) {
    case 18: {
      return h(
        'div',
        {
          class: `${Services.contacts}-form__custom-field`
        },
        [
          renderCustomTextField.call(this, h, field, index),
          renderPermanentButton.call(this, h, field)
        ]
      )
    }
    default: {
      return renderCustomTextField.call(this, h, field, index)
    }
  }
}

function renderFieldCustom(h) {
  if (!this.isFilter) {
    return h(
      components['expansion-panels'],
      {
        props: {
          flat: true,
          outline: true,
          rounded: true
        }
      },
      [
        h(
          components['expansion-panel'],
          {
            scopedSlots: {
              header: ({ expanded }) => {
                return h(
                  'div',
                  {
                    class: 'default-expansion-panel-header'
                  },
                  [
                    this.getTranslate(`${Services.contacts}.titles.custom.fields`),
                    h(arrow, { props: { expanded } })
                  ]
                )
              }
            }
          },
          [
            h(
              'div',
              {
                class: `${Services.contacts}-form__custom-fields`
              },
              this.customFields.map((field, index) => {
                return renderCustomField.call(this, h, field, index)
              })
            )
          ]
        )
      ]
    )
  }
}

function renderValidationInfo(h) {
  if (this.validationErrorInfo) {
    return h(
      info,
      {
        class: `${Services.contacts}-form__validation`,
        props: {
          value: this.validationErrorInfo,
          color: Colors.error
        }
      }
    )
  }
}

export default function(h) {
  return h(
    components.form,
    {
      class: {
        [`${Services.contacts}-form`]: true,
        [`${Services.contacts}-form--filter`]: this.isFilter
      }
    },
    [
      renderFieldPhone.call(this, h),
      renderFieldEmail.call(this, h),
      renderFieldLastName.call(this, h),
      renderFieldFirstName.call(this, h),
      renderFieldMiddleName.call(this, h),
      renderFieldGender.call(this, h),
      renderFieldDate.call(this, h),
      renderFieldCustom.call(this, h),
      renderValidationInfo.call(this, h)
    ]
  )
}
